import Vue from 'vue'
import Vuex from 'vuex'

import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'

Vue.use(Vuex);

var store = {
    state: {
        _id: false,
        id: false,
        pages: ['home'],
        terms: '',
        pay: {
            amount: '100.00'
        },
        offers: false,
        survey: false,
        TsCs: '',
        user: false,
        auth: false,
        name: '',
        phone: false,
        customer_id: false,
        customerID: false,
        iss: false,
        copper: false,
        clientCampaigns: [],
        host: '',
        cameraId: '',
        cameras: [],
        processedQuery: false,
        camera: false,
        MDCode: ''
    },
    actions: {
        wsAction ({ state, commit }, msg ) {
            console.log('wsAction',msg);
            switch ( msg.t ) {
                case 'startSurvey':
                    commit('setSurvey',msg.data);
                    break;
                case 'updatePhone':
                    commit('setValue',{ k: 'name', v: msg.data.name });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'phone', v: msg.data.phone });  
                    break;
                case 'startCustomer':
                    commit('setValue',{ k: 'customerID', v: msg.data.customerID });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'iss', v: msg.data.iss });
                    break;
                 case 'copperhouse':
                     var customer = msg.data.customer
                     if ( customer ) {
                         commit('setValue',{ k: 'copper', v: { phone: customer.phone, msisdn: customer.msisdn, name: customer.name, email: customer.email, _id: customer._id }});
                     }   

            }
           

        },
        getTerms ({ state, commit }) {
            if ( state.terms ) return;
            WebSoc.SEND({ t: 'getTsCs' },resp => {
                commit('saveTerms',resp.tscs);
                
            })
        },
        getOffers ({ state, commit }, campaign_id ) {
            if ( state.offers ) return;
            WebSoc.SEND({ t: 'getOffers', data: { campaign_id } },offers => {
                commit('saveOffers',offers)
            })
        }
    },
    mutations: {
        setValue ( state, { k, v }) {
            //console.log('setValue',{ k, v });
            state[k] = v;
            return;
            k == 'auth' && console.log('auth v',v);
            if ( k == 'auth' && v.client_id ) {
                WebSoc.SEND({ t: 'getClientCampaigns', data: { client_id: v.client_id, loyaltyId: v.id  }},campaigns => {
                    console.log('getClientCampaigns campaigns',campaigns)
                    state.clientCampaigns = campaigns;
                })
            }
        },
        setKeyValue ( state, { item, k, v }) {
            item[k] = v;
        },
        setAuth ( state, auth ) {
            //console.log('setAuth',auth);
            state.auth = auth;
            store.mutations.setValue(state,{ k: 'auth', v: auth });

            if ( !auth ) return;
            try {
                localStorage.loyalty_id = auth._id;
                localStorage.loyaltyId = auth.id;
            } catch(e) {

            }
        },
        setSurvey ( state, survey ) {
            survey.pages.forEach(p => p.date = Date.now());
            state.survey = survey;
            state.pages.push('survey');
        },
        saveTerms ( state, terms ) {
            state.terms = terms;
        },
        saveOffers ( state, offers ) {
            console.log('saveOffers')
            state.offers = offers;
        },
        setPages ( state, pages ) {
            state.pages = pages;
        },
        pushPage ( state, page ) {
            if ( !page ) return;
            state.pages.indexOf(page) == -1 && state.pages.push(page);         
        },
        popPage ( state, page ) {           
            setTimeout(() => {
                if ( page ) { var indexPage = state.pages.indexOf(page) }
                if ( page && indexPage == -1 ) return;
                if ( !page ) return console.log('must specify popPage');
                state.pages.splice(indexPage,1);
            },500)
        }
    }
}

export default new Vuex.Store(store);